import { makeStyles } from 'tss-react/mui';

const useTermsAgreementStyles = makeStyles()((theme) => ({
  terms: {
    boxSizing: 'border-box',
    padding: theme.spacing(3),
  },
}));

export default useTermsAgreementStyles;
